import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { browserClient } from '../client/browser';
import {
    BffGetPacksResponse,
    BffGetPopularWithListenersResponse,
    BffGetRecentsFavoritesByCategoryResponse,
    BffHealthCheckResponse,
} from './types';

type BffParams = {
    circleId: number;
    circleAuthorizationToken: string;
    rHGApp: string;
};

function getHeaders(accessToken: string, params: BffParams) {
    return {
        Authorization: `Bearer ${accessToken}`,
        'circle-authorization-token': params.circleAuthorizationToken,
        'x-device-platform': 'www',
        'rhg-app': params.rHGApp,
    };
}

/**
 * TODO: write OpenAPI specs for the BFF API and use them to generate the client API service SDK
 * instead of writing all this by hand
 */
export function createBffApi(
    accessToken: () => Promise<string>,
    client: AxiosInstance = browserClient
) {
    return {
        healthCheck: async (
            params: BffParams,
            configOverrides?: AxiosRequestConfig
        ) => {
            const accessTokenValue = await accessToken();
            const path = `/api/v1/bff/${params.circleId}/health-check`;
            return client.get<BffHealthCheckResponse>(path, {
                ...configOverrides,
                headers: {
                    ...getHeaders(accessTokenValue, params),
                    ...configOverrides?.headers,
                },
            });
        },
        getPacks: async (
            params: BffParams & { packIds: string[] },
            configOverrides?: AxiosRequestConfig
        ) => {
            const accessTokenValue = await accessToken();
            const path = `/api/v1/bff/${params.circleId}/packs`;
            return client.get<BffGetPacksResponse>(path, {
                ...configOverrides,
                params: {
                    packIds: params.packIds.join(','),
                },
                headers: {
                    ...getHeaders(accessTokenValue, params),
                    ...configOverrides?.headers,
                },
            });
        },
        getPopularWithListeners: async (
            params: BffParams,
            configOverrides?: AxiosRequestConfig
        ) => {
            const accessTokenValue = await accessToken();
            const path = `/api/v1/bff/${params.circleId}/popular-with-listeners`;
            return client.get<BffGetPopularWithListenersResponse>(path, {
                ...configOverrides,
                headers: {
                    ...getHeaders(accessTokenValue, params),
                    ...configOverrides?.headers,
                },
            });
        },
        getRecentsFavoritesByCategory: async (
            params: BffParams,
            configOverrides?: AxiosRequestConfig
        ) => {
            const accessTokenValue = await accessToken();
            const path = `/api/v1/bff/${params.circleId}/recents-favorites-by-category`;
            return client.get<BffGetRecentsFavoritesByCategoryResponse>(path, {
                ...configOverrides,
                headers: {
                    ...getHeaders(accessTokenValue, params),
                    ...configOverrides?.headers,
                },
            });
        },
    };
}
